import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '../components/LanguageSwitcher';
import { Button } from '../components/Button';
import './Nav.css';

export function Nav() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 8);
    handler();
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <header className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
      <div className="container nav__inner">
        <a href="/" className="nav__brand" aria-label="Ananeos home" onClick={() => setMenuOpen(false)}>
          <img
            src="/logos/ananeos-logo-full-light-1200.png"
            alt="Ananeos"
            className="nav__logo"
            height="32"
          />
        </a>

        <nav className={`nav__links ${menuOpen ? 'nav__links--open' : ''}`}>
          <a href="#capabilities" onClick={() => setMenuOpen(false)}>{t('nav.capabilities')}</a>
          <a href="#products" onClick={() => setMenuOpen(false)}>{t('nav.products')}</a>
          <a href="#about" onClick={() => setMenuOpen(false)}>{t('nav.about')}</a>
          <a href="#contact" onClick={() => setMenuOpen(false)}>{t('nav.contact')}</a>
        </nav>

        <div className="nav__actions">
          <LanguageSwitcher />
          <Button as="a" href="#newsletter" size="md" className="nav__cta">
            {t('nav.newsletter')}
          </Button>
          <button
            className="nav__burger"
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
    </header>
  );
}
